import { atom } from 'recoil';

const productErrorAtom = atom({
  key: 'productError',
  default: {
    Name: '',
    Subname: '',
    Description: '',
    Composition: '',
    Vat: '',
    Discount: '',
    DiscountPrice: '',
    OriginalPrice: ''
  }
});

export { productErrorAtom };
